import { createContext, type PropsWithChildren, useContext, useEffect, useState } from 'react'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { VoicemailDropStore } from '../store/voicemailDropStore'

export const VoicemailDropContext = createContext<VoicemailDropStore | null>(null)

export const useVoicemailDropContext = () => {
  const context = useContext(VoicemailDropContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with VoicemailDropContext')

  return context
}

export const VoicemailDropProvider = ({ children }: PropsWithChildren) => {
  const entities = useEntitiesContext()
  const [store] = useState(() => new VoicemailDropStore(entities))

  useEffect(() => {
    void store.init()
  }, [store])

  return <VoicemailDropContext.Provider value={store}>{children}</VoicemailDropContext.Provider>
}
